import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
}

export const ourteamSlice = createSlice({
  name: 'ourteamSliceName',
  initialState,
  reducers: {
    addOurteam: (state) => {
      state.loading = true;
    },
    getOurteam: (state) => {
      state.loading = true;
    },
    getOneOurteam: (state) => {
      state.loading = true;
    },

    successOurteam: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    removeOurteam: (state) => {
      state.loading = true;
    },
    updateOurteam: (state) => {
      state.loading = true;
    },
    failedOurteam: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { addOurteam, removeOurteam, updateOurteam, getOurteam, successOurteam, getOneOurteam, failedOurteam } = ourteamSlice.actions

export default ourteamSlice.reducer